import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <div className="table-header-subtitle mb-15">
                {this.props.t('opportunities.year.subtitle', {
                    last_year: this.props.lastYear,
                    current_year: this.props.currentYear,
                })}
            </div>
        );
    }
}

export default ExtraButtons;
